import { useRouter } from 'next/router'
import { useContext, useEffect } from 'react'
import {
  SearchContext,
  HeaderContext,
} from '@izettle/public-site-components/dist/help-center'

export const useCloseOverlaysOnRouteChange = () => {
  const router = useRouter()
  const { close: closeSearch } = useContext(SearchContext)
  const { closeMobileNav } = useContext(HeaderContext)

  const handleRouteChange = () => {
    closeSearch()
    closeMobileNav()
  }

  useEffect(() => {
    router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [])
}
